import React from "react";
import { CircularProgress, Typography } from "@mui/material";

import MinimalLayoutWrapper from '../shared/MinimalLayoutWrapper';

const Loading = () => {

    return (
        <MinimalLayoutWrapper>
            <CircularProgress sx={{ m: 4 }} />
            <Typography component="h1" variant="h6" sx={{ m: 0 }}>
                Loading
            </Typography>
        </MinimalLayoutWrapper>
    );
};

export default Loading;
